import { getEntityTemplateLang } from '~services/entity-definitions/helpers';
import { createTemporaryEntityId } from '~services/entity-definitions/template-helpers';

export default () => {
  return {
    data: {
      type: 'paragraph--bgcontainer',
      id: createTemporaryEntityId(),
      attributes: {
        langcode: getEntityTemplateLang(),
        status: true,
        default_langcode: true,
        field_hide_title: false,
        field_title: { value: 'BG Container', format: 'rich_text' },
        field_css_color_class: null,
        field_padding_top: null,
        field_padding_bottom: null,
      },
      relationships: {
        field_modules: {
          data: [],
        },
      },
      permissions: {
        update: true,
        create: true,
        delete: true,
      },
    },
  };
};
